import { render, staticRenderFns } from "./declarationRules.vue?vue&type=template&id=08333d1b&scoped=true"
import script from "./declarationRules.vue?vue&type=script&lang=js"
export * from "./declarationRules.vue?vue&type=script&lang=js"
import style0 from "./declarationRules.vue?vue&type=style&index=0&id=08333d1b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08333d1b",
  null
  
)

export default component.exports